import React from 'react'
import { Link } from 'react-router-dom'
import Spotlight from './spotlight'
import Banner from './banner'
import user from './user'
import AdvertisementView from './advertisement-view'
import FeedComponent from './feed-component'
import { Content } from './dynamiccontent'


export default class Home extends React.Component {
	render() {
		return (
			<div>
				<Banner className="main" />
				<Content className="banner secondary" content={hp.store.banner_secondary} />
				<div className="row no-gutters home">
					<div className="col-sm-12 col-md-10 px-5">
						{/*
						<h4>{__('socials_premium')}</h4>
						<Spotlight
							//className="row spotlight no-gutters members justify-content-center"
							className="members"
							items={hp.store.members.premium}
							slidesToShow={6}
							variableWidth={true}
							autoPlay={true}
							renderItem={(item, i) => (
								<Link to={'/home/profile/' + item.id} key={item.id} className="item">
									<img src={item.spotlight_img || item.img} />
								</Link>
							)}
							responsive={[
								{breakpoint: 1260, settings: {slidesToShow: 4}},
								{breakpoint: 760, settings: {slidesToShow: 3}},
							]}
						/>

						<hr/>
						<div>
							<h4 className="float-left">{__('news_recent')}</h4>
							<Link to="/home/news" className="float-right">{__('news_more')}</Link>
						</div>
						<div className="clearfix" />
						*/}
						<Spotlight
							className="news-highlights"
							items={hp.store.news}
							autoPlay={true}
							arrows={true}
							breakpoints={[
								{ width: 760, numItemsVisible: 1 }
							]}
							renderItem={item => (
								<Link to={"/home/news/" + item.id} key={item.id} className="item item-news mx-2">
									<div className="card news">
										{item.high_img ? <img src={item.high_img} alt="" className="card-img-top" /> : null}
									</div>
									<div className="card-body bold">
										{item.name || item.nick}
									</div>
								</Link>
							)}
							responsive={[
								{breakpoint: 1260, settings: {slidesToShow: 2}},
								{breakpoint: 760, settings: {slidesToShow: 1}},
							]}
						/>
						{/*
						<hr/>
						<h4>{__('socials_partner')}</h4>
						<Spotlight
							className="members partner"
							items={hp.store.members.partner}
							arrows={true}
							autoPlay={true}
							slidesToShow={6}
							variableWidth={true}
							renderItem={(item, i) => (
								<Link to={'/home/profile/' + item.id} key={item.id} className="item">
									<img src={item.spotlight_img || item.img} />
								</Link>
							)}
							responsive={[
								{breakpoint: 1260, settings: {slidesToShow: 4}},
								{breakpoint: 760, settings: {slidesToShow: 3}},
							]}
						/>
						*/}
						<hr/>
						<div>
							<h4 className="float-left">{__('socials_partner_pubs')}</h4>
							<Link to='/home/feed' className="float-right">{__('socials_pub_more')}</Link>
						</div>
						<div className="clearfix" />
						<FeedComponent uid={0} />
					</div>
					<div className="col-sm-12 col-md-2 px-4">
						<h6>{__('socials_advertisement')}</h6>
						<div className="row no-gutters advertisement">
							<AdvertisementView alias="advertisement-home" random={1} />
						</div>
					</div>
				</div>
			</div>
		)
	}
}
